<mat-dialog-content class="locations-picking">
  <table mat-table [dataSource]="data" class="mat-elevation-z8">
    <ng-container matColumnDef="origin">
      <th mat-header-cell *matHeaderCellDef> Origen </th>
      <td mat-cell *matCellDef="let element"> {{element.origin}} </td>
    </ng-container>
    <ng-container matColumnDef="message">
      <th mat-header-cell *matHeaderCellDef> Mensaje </th>
      <td mat-cell *matCellDef="let element"> {{element.message}} </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</mat-dialog-content>
<div
    class="d-flex justify-content-center flex-column align-items-center section-button c-b"
  >
    <button
      id="confirmComponentYes"
      mat-flat-button
      class="button-primary-event button-success"
      [mat-dialog-close]="'true'"
    >
      Salir
    </button>
  </div>